import React, { useEffect, useState } from "react";

const AM_STYLES = `
.am-backdrop {
  position: fixed; inset: 0;
  background: rgba(15,23,42,0.45);
  z-index: var(--z-backdrop);
  display: flex; align-items: center; justify-content: center;
  opacity: 0; pointer-events: none;
  transition: opacity 0.18s ease;
  padding: 16px;
}
.am-backdrop.open { opacity: 1; pointer-events: auto; }
.am-modal {
  background: #fff;
  border: 1px solid #E6E6E6;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  width: 480px; max-width: 100%;
  max-height: calc(100vh - 32px);
  display: flex; flex-direction: column;
  transform: translateY(8px);
  transition: transform 0.18s ease;
  font-family: 'Montserrat', sans-serif;
  overflow: hidden;
}
.am-backdrop.open .am-modal { transform: translateY(0); }
.am-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 16px 24px; flex-shrink: 0;
}
.am-title {
  font-size: 20px; font-weight: 600; color: #1E1E1E;
  font-family: 'Montserrat', sans-serif;
}
.am-close {
  background: none; border: none; cursor: pointer;
  padding: 4px; color: #1E1E1E;
  display: inline-flex; align-items: center; justify-content: center;
}
.am-close:hover { opacity: 0.7; }
.am-close svg { width: 16px; height: 16px; display: block; }
.am-divider { height: 1px; background: #E6E6E6; flex-shrink: 0; }
.am-body {
  padding: 20px 24px;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px; font-weight: 400; color: #1E1E1E;
  overflow-y: auto; flex: 1;
  line-height: 1.6;
}
.am-foot { padding: 16px 24px 20px; flex-shrink: 0; }
.am-ok-btn {
  width: 100%; height: 48px;
  background: #2965AD; color: #fff;
  border: none; border-radius: 8px;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px; font-weight: 500;
  cursor: pointer;
}
.am-ok-btn:hover { background: #1e4f8a; }
`;

interface AlertModalV2Props {
  title?: string;
  message: string;
  onClose: () => void;
}

function AlertModalV2({ title, message, onClose }: AlertModalV2Props) {
  const [visible, setVisible] = useState(false);
  useEffect(() => { const id = requestAnimationFrame(() => setVisible(true)); return () => cancelAnimationFrame(id); }, []);
  return (
    <>
      <style>{AM_STYLES}</style>
      <div className={"am-backdrop" + (visible ? " open" : "")}>
        <div className="am-modal" role="dialog" aria-modal="true">
          <div className="am-head">
            <span className="am-title">{title || "Alert"}</span>
            <button className="am-close" onClick={onClose} aria-label="Close">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>
          <div className="am-divider" />
          <div className="am-body" dangerouslySetInnerHTML={{ __html: message }} />
          <div className="am-divider" />
          <div className="am-foot">
            <button className="am-ok-btn" onClick={onClose}>Ok</button>
          </div>
        </div>
      </div>
    </>
  );
}

export default AlertModalV2;
